<template>
  <div class="vertical-nav-header d-flex align-center justify-space-between ps-6 pe-5 pt-5 pb-2">
    <router-link
      to="/"
      class="d-flex align-center text-decoration-none mx-auto"
    >
      <v-img
        :src="appLogo"
        max-height="30px"
        max-width="30px"
        alt="logo"
        contain
        eager
        class="app-logo me-3"
      ></v-img>
      <v-slide-x-transition v-if="selectedLab.laboratory_name === 'Iluminar'">
        <h2
          v-show="!(menuIsVerticalNavMini && !isMouseHovered)"
          class="app-title text--primary"
        >
          {{ appName }}
        </h2>
      </v-slide-x-transition>
      <v-slide-x-transition v-else>
        <v-progress-circular
          v-if="loading"
          indeterminate
          :width="3"
          :size="30"
          color="primary"
          
        ></v-progress-circular>
        <v-img
        v-if="labSettings && !loading"
        max-width="130px"
        alt="logo-lab"
        contain      
        :src="labSettings.rectangular_logo_2 ? labSettings.rectangular_logo_2 : labSettings.rectangular_logo_1"    
        ></v-img>
        <v-img
        v-if="!labSettings && !loading"
        max-width="130px"
        alt="logo-lab"
        contain      
        :src="require('@/assets/logos/PNG/Recurso 15.png')"    
        ></v-img>
      </v-slide-x-transition>
    </router-link>

    <v-slide-x-transition>
      <div
        v-show="!(menuIsVerticalNavMini && !isMouseHovered)"
        v-if="$vuetify.breakpoint.lgAndUp"
        class="d-flex align-center ms-1"
        @click.stop="menuIsVerticalNavMini = !menuIsVerticalNavMini"
      >
        <v-icon
          v-show="!menuIsVerticalNavMini"
          size="20"
          class="cursor-pointer"
        >
          {{ icons.mdiRecordCircleOutline }}
        </v-icon>
        <v-icon
          v-show="menuIsVerticalNavMini"
          size="20"
          class="cursor-pointer"
        >
          {{ icons.mdiRadioboxBlank }}
        </v-icon>
      </div>
      <v-icon
        v-else
        size="20"
        class="d-inline-block"
        @click.stop="$emit('close-nav-menu')"
      >
        {{ icons.mdiClose }}
      </v-icon>
    </v-slide-x-transition>
  </div>
</template>

<script>
import { mdiRadioboxBlank, mdiRecordCircleOutline, mdiClose } from '@mdi/js'
import useAppConfig from '@core/@app-config/useAppConfig'
import themeConfig from '@themeConfig'
import { inject, computed } from '@vue/composition-api'
import store from '@/store'

export default {
  methods: {
    async getLabCustomization() {
      this.$store.dispatch('session/setCustomizationLoading', true)
      try {
        const response = await this.$api.getLabCustomization()
        if(response.status === 200) {
          let form = {
            rectangular_logo_1: response.data.get_rectangular_logo_1,
            rectangular_logo_2: response.data.get_rectangular_logo_2,
          }
          await this.$store.dispatch('session/setLabSettings', form)
          this.$vuetify.theme.themes.light.primary = response.data.system_color_primary ?? '#1976D2'
          this.$vuetify.theme.themes.light.secondary = response.data.system_color_secondary ?? '#424242'

          await this.$nextTick()
        }
      }catch (e) {
        if(!e.response) {
          this.$emit('timeout-alert')
        }
        await this.$store.dispatch('session/setLabSettings', null)
      } finally {
        this.$store.dispatch('session/setCustomizationLoading', false)
      }
    },
  },
  mounted() {
    this.getLabCustomization()
  },
  computed: {
    selectedLab() {
      return this.$store.getters['session/selectedLaboratory']()
    },
    loading() {
      return this.$store.getters['session/customizationLoading']()
    },
  },
  setup() {
    const { menuIsVerticalNavMini } = useAppConfig()
    const isMouseHovered = inject('isMouseHovered')
    const labSettings = computed(() => {
      return store.getters['session/labSettings']()
    })

    return {
      menuIsVerticalNavMini,
      isMouseHovered,
      appName: themeConfig.app.name,
      appLogo: themeConfig.app.logo,
      labSettings,

      // Icons
      icons: {
        mdiClose,
        mdiRadioboxBlank,
        mdiRecordCircleOutline,
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.app-title {
  font-size: 1.25rem;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.3px;
}

// ? Adjust this `translateX` value to keep logo in center when vertical nav menu is collapsed (Value depends on your logo)
.app-logo {
  transition: all 0.18s ease-in-out;
  .v-navigation-drawer--mini-variant & {
    transform: translateX(-4px);
  }
}
</style>
